import { useForm, zodResolver } from '@mantine/form';
import { useEffect } from 'react';
import { z } from 'zod';

import { TransactionType } from '@e-origin/shared';

import { useCreateTransactionType, useEditTransactionType } from '@admin/hooks';

const transactionTypeSchema = z.object({
  name: z.string().min(1, { message: 'Transaction type name is required' }),
  typeId: z.number(),
  maxValue: z.number(),
});

export const useEditTransactionTypeFormInitializer = ({ transactionType }) => {
  const createTransactionTypeMutation = useCreateTransactionType();
  const editTransactionTypeMutation = useEditTransactionType();

  const onSubmit = async (values) => {
    if (values._id) {
      return await editTransactionTypeMutation.mutateAsync(values);
    } else {
      return await createTransactionTypeMutation.mutateAsync(values);
    }
  };

  const buildInitialValues = (transactionType: TransactionType) => ({
    _id: transactionType?._id,
    name: transactionType?.name || '',
    typeId: transactionType?.typeId || 1,
    maxValue: transactionType?.maxValue || 1,
  });

  const form = useForm({
    initialValues: buildInitialValues(transactionType),
    validate: zodResolver(transactionTypeSchema),
    validateInputOnBlur: true,
  });

  useEffect(() => {
    form.setValues(buildInitialValues(transactionType));
  }, [transactionType]);

  return {
    form,
    onSubmit,
    isSubmitting: createTransactionTypeMutation.isPending || editTransactionTypeMutation.isPending,
  };
};
